import { render, staticRenderFns } from "./ManageTeamTab.vue?vue&type=template&id=73040afc&scoped=true"
import script from "./ManageTeamTab.vue?vue&type=script&lang=js"
export * from "./ManageTeamTab.vue?vue&type=script&lang=js"
import style0 from "./ManageTeamTab.vue?vue&type=style&index=0&id=73040afc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73040afc",
  null
  
)

export default component.exports